import InputDate from "@/components/form/InputDate";
import InputText from "@/components/form/InputText";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  CircularProgress,
} from "@mui/material";

import dayjs from "dayjs";
import { Control } from "react-hook-form";

interface AddExamDialogProps {
  open: boolean;
  analyteName: string | null;
  onClose: () => void;
  onAdd: () => Promise<void>;
  isSubmitting: boolean;
  control: Control<any>;
  inputKey: number;
  newExamsLength: number;
}

export const AddExamDialog = ({
  open,
  analyteName,
  onClose,
  onAdd,
  isSubmitting,
  control,
  inputKey,
  newExamsLength,
}: AddExamDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Adicionar Resultado para {analyteName}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <InputDate
            key={`date-${inputKey}`}
            label="Data de referência"
            name={`newExames.${newExamsLength}.date`}
            control={control}
            defaultValue={dayjs()}
          />
          <Stack direction="row" spacing={2}>
            <InputText
              key={`value-${inputKey}`}
              label="Valor"
              name={`newExames.${newExamsLength}.value`}
              control={control}
              sx={{ flexGrow: 1 }}
            />
            <InputText
              key={`unit-${inputKey}`}
              label="Unidade"
              name={`newExames.${newExamsLength}.unit`}
              control={control}
              sx={{ width: 120 }}
            />
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button
          variant="contained"
          onClick={onAdd}
          disabled={isSubmitting}
          startIcon={
            isSubmitting ? <CircularProgress size={20} color="inherit" /> : null
          }
        >
          {isSubmitting ? "Adicionando..." : "Adicionar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
